import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-size-14 font-weight-bold" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mt-1 text-size-12" }, "\n        ミュートすると事業所のお仕事が一覧に表示されなくなります\n      ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "my-2 text-size-12" }, [
  /*#__PURE__*/_createTextVNode("\n          今後のサービス運営のために率直なご意見をお聞かせください"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("\n          ミュートする理由については事業所様には伝わりません\n        ")
], -1)

import AppButton from "@/components/atoms/button/AppButton.vue";
import TextAreaGroup from "@/components/molecules/form/TextAreaGroup.vue";
import { required } from "@vee-validate/rules";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OfficeMuteModal',
  props: {
  isShown: {
    type: Boolean,
    default: false
  },
  officeName: {
    type: String,
    required: true
  }
},
  emits: ["submit", "cancel"],
  setup(__props, { emit }) {

const props = __props;



const reason = ref("");


function clearForm() {
  reason.value = "";
}

function onCancel() {
  emit("cancel");
  clearForm();
}

function onSubmit() {
  emit("submit", { reason: reason.value });
  clearForm();
}

return (_ctx: any,_cache: any) => {
  const _component_ValidationProvider = _resolveComponent("ValidationProvider")!
  const _component_BModal = _resolveComponent("BModal")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!

  return (_openBlock(), _createBlock(_component_CustomValidationObserver, { ref: "form" }, {
    default: _withCtx(({ handleSubmit }) => [
      _createVNode(_component_BModal, {
        modelValue: __props.isShown,
        title: "事業所ミュートの登録",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        centered: "",
        onClose: onCancel,
        onHide: onCancel
      }, {
        "modal-footer": _withCtx(() => [
          _createVNode(AppButton, {
            class: "text-weight-500",
            variant: "mild",
            onClick: onCancel
          }, {
            default: _withCtx(() => [
              _createTextVNode("\n          キャンセル\n        ")
            ], undefined, true),
            _: 1
          }),
          _createTextVNode(),
          _createVNode(AppButton, {
            class: "ml-2 text-weight-500",
            variant: "primary",
            onClick: ($event: any) => (handleSubmit(onSubmit))
          }, {
            default: _withCtx(() => [
              _createTextVNode("\n          ミュートする\n        ")
            ], undefined, true),
            _: 2
          }, 1032, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, _toDisplayString(__props.officeName) + "をミュートリストに登録します", 1)
          ]),
          _createTextVNode(),
          _hoisted_2,
          _createTextVNode(),
          _createVNode(_component_ValidationProvider, {
            rules: { required: _unref(required), max: 2000 },
            name: "ミュートする理由",
            tag: "div",
            class: "mt-2",
            vid: "reason"
          }, {
            default: _withCtx((validationState) => [
              _createVNode(TextAreaGroup, {
                modelValue: reason.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((reason).value = $event)),
                appLabelText: "必須",
                label: "ミュートする理由",
                validationState: validationState,
                class: "mt-1"
              }, null, 8, ["modelValue", "validationState"]),
              _createTextVNode(),
              _hoisted_3
            ]),
            _: 1
          }, 8, ["rules"]),
          _createTextVNode()
        ], undefined, true),
        _: 2
      }, 1032, ["modelValue"])
    ]),
    _: 1
  }, 512))
}
}

})